

import category from ".";
import { toggleModal, ADD_CATEGORY_TO_LIST, UPDATE_CATEGORY_IN_LIST, DELETE_CATEGORY_FROM_LIST, ADD_CATEGORIES_TO_LIST } from "./mutation-types";

export default {

        [toggleModal]: (state, value) =>{
            state.isShowAddOrUpdateModal = value;
        },

        [ADD_CATEGORIES_TO_LIST]: (state, categoriesList) =>{
            state.categoriesList = categoriesList ;
        },
        
        [ADD_CATEGORY_TO_LIST]: (state, category) =>{
            state.categoriesList.push(category);
        },

        [UPDATE_CATEGORY_IN_LIST]: (state, updatedCategory) =>{
            const index = state.categoriesList.findIndex(category => category.id === updatedCategory.id);
            state.categoriesList[index] = updatedCategory
        },

        [DELETE_CATEGORY_FROM_LIST]: (state, categoryIDs) => {
            state.categoriesList.forEach((element, index) => { 
                categoryIDs.forEach(id=>{
                     if( id == element.id || id === element.id){
                        state.categoriesList.splice(index, 1);
                     }
                        
                });
            });

          },
          
}
